var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useSWR from 'swr';
import { useAlertServiceClient } from './useAlertServiceClient';
export function useAlert(id, includeRecipients) {
    const alertServiceClient = useAlertServiceClient();
    return useSWR(['/alert', id, includeRecipients], (_a) => __awaiter(this, [_a], void 0, function* ([, id, includeRecipients]) {
        return alertServiceClient.getAlert(id, includeRecipients ? undefined : ['RECIPIENTS']);
    }), {
        revalidateOnFocus: false,
    });
}
